// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash/flowRight';
import Text from 'crehana-ui/Text';
import { useTranslation } from '@crehana/i18n';
import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import CartItem from './CartItem';
import GET_PAYMENT_METHODS_QUERY from '../../graphql/getPaymentMathods.graphql';

const Content = styled.div`
  display: block;
  & > * + * {
    border-top: 1px solid #dfe1e6;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 24px;
  }
`;

const PaymentMethodsContainer = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: block;
    margin-top: 40px;
  }
`;

const PaymentLogoImg = styled.img`
  display: inline-flex;
  max-height: 18px;
  margin-right: 12px;
  margin-bottom: 8px;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
`;

type CourseType = {
  originalId: string;
};

type ShoppingCartItemsType = {
  items: CourseType[];
  loading: boolean;
  payments: string[];
};

const ShoppingCartItems = ({
  items,
  loading,
  payments,
}: ShoppingCartItemsType) => {
  const [loadingRemove, setLoadingRemove] = React.useState(null);
  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  return (
    <React.Fragment>
      <Content id="wrapper" data-cy="shoppingCartList">
        {items.map(item => (
          <li key={`shoppingcart-${item.originalId}`}>
            <CartItem
              item={item}
              loadingRemove={loadingRemove === item.originalId}
              setLoadingRemove={setLoadingRemove}
              origin="Shopping cart items section"
            />
          </li>
        ))}
      </Content>
      {loading ? null : (
        <PaymentMethodsContainer>
          <div className="mb-16">
            <Text color="gray-dark" responsive="none" type="caption">
              {t('AVAILABLE_PAYMENTS')}
            </Text>
          </div>
          <div>
            {payments.splice(0, 10).map((payment, i) => (
              <PaymentLogoImg key={i} src={payment} alt={`payment-${i}`} />
            ))}
          </div>
        </PaymentMethodsContainer>
      )}
    </React.Fragment>
  );
};

export default compose(
  graphql(GET_PAYMENT_METHODS_QUERY, {
    props: ({ data: { loading, paymentGatewayStore } }) => ({
      loading,
      payments: paymentGatewayStore
        ? paymentGatewayStore
            .map(payment => payment.paymentStore.logo)
            .filter(payment => payment !== null)
        : [],
    }),
  }),
)(ShoppingCartItems);
